import { throttle } from "throttle-debounce";
import { Accordion, Collapse, Tooltip } from "bootstrap";
import Preload from "components/divider/index";
import RotatingButton from "components/button/index";
import SuperHeader from "components/superheader/index";
import Carousel from "components/carousel/index";
import ImageGallery from "components/image-gallery/index";
import ActiveMenuItem from "components/menu/index";
import Fact from "components/fact/index";
import Dropdown from "components/dropdown/index";
import Input from "components/input/index";
import GuitarStrings from "components/guitar-strings/index";

export default class Global {
  initOnDOMContentLoaded() {
    console.log('loaded')
    new Preload().init()
    new RotatingButton().init()
    new SuperHeader().init()
    new Carousel().init()
    new ImageGallery().init()
    new ActiveMenuItem().init()
    new Fact().init()
    new Dropdown().init()
    new Input().init()
    new GuitarStrings().init()

    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
      return new Tooltip(tooltipTriggerEl)
    })
  }

  initOnWindowload() {}
}
